import angular from 'angular';

import NumberOnlyDirective, { selector } from './number-only.directive';

export default angular
    .module('application.directive.number-only', [])
    .directive(selector, NumberOnlyDirective);



// WEBPACK FOOTER //
// ./src/application/directive/number-only/index.js